<script>
import IconNote from '@/components/icon/IconNote.vue';
import constants from '@/constants';

export default {
    computed: {
        constants() {
            return constants;
        },
        pendingCount() {
            return this.$store.getters.PENDING_REQUESTS_COUNT;
        },
    },
    components: {
        ButtonIcon: IconNote,
    },
};
</script>

<template>
    <router-link
        class="left_button_main_container button_with_badge"
        :to="{ name: constants.ROUTER_NAME.CORPORATEREQUESTS }"
    >
        <div class="left_button_icon_container">
            <ButtonIcon iconWidth="16px" iconHeight="16px" />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Corporate Requests</label>
        </div>
        <span v-if="pendingCount > 0" class="badge_count">{{
            pendingCount
        }}</span>
    </router-link>
</template>

<style scoped>
.button_with_badge {
    position: relative;
}

.badge_count {
    position: absolute;
    top: -6px;
    right: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    background: #ff9800;
    color: white;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
